export default {
    achievement_locked: 'Ítem bloqueado',
    all_avatars: 'Expresa tu personalidad y tus gustos con increíbles avatares',
    all_skins: 'Personaliza tu experiencia en Beeverso con tu skin preferido',
    all_the_books: 'Canjea tus recompensas por libros llenos de emocionantes aventuras y conocimiento',
    avatars: 'Avatares',
    books: 'Libros',
    buy: 'Comprar',
    buy_this_book: 'Comprar este libro',
    buy_this_pack: 'Comprar este pack',
    buy_this_skin: 'Comprar este skin',
    cost: 'cuesta:',
    favorites: 'Favoritos',
    insufficient_beecoins: 'BeeCoins insuficientes',
    item_successfully_purchased: 'Artículo comprado <b>con éxito</b>',
    learn_more: 'Los 10 libros más leídos por nuestros lectores',
    magazines: 'Lecturas',
    articles_and_more: 'Libros, revistas y mucho más',
    next: 'Siguiente',
    of: ' de ',
    pack_of: 'Pack de',
    preview: 'Previsualizar',
    previous: 'Anterior',
    return: 'Volver',
    search: '¿Qué te gustaría leer hoy?',
    skins: 'Skins',
    this_book: 'Este libro',
    this_pack: 'Este pack',
    this_skin: 'Este skin',
    you_have: 'Tienes',
}
